import { Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { CustomerService } from '../../../_services/customer.service';
import { ParameterData } from '../../../_helpers/index';
import { Router, ActivatedRoute } from '@angular/router';
import { DataService } from '../../../_helpers/dataservice.service'
import { UserService } from '../../../_services';
import { debtorPhonePrefix, DocumentService } from '../../../_enums/debtordocumenttype';
import { User, ChangePassword } from '../../../_models/index';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { AuthService } from '../../../_services/auth.service';
import { ConfirmPasswordValidator } from '../../confirm-password.validator';

@Component({
    selector: 'app-old-profile',
    templateUrl: './old-profile.component.html',
    styleUrls: ['../../../../assets/css/customer-list-table.css']
})

export class OldProfileComponent implements OnInit {

    public customer_public_id: string;
    userKcoreId: any;
    editUserName: any;

    public profileForm: FormGroup;
    public passwordForm: FormGroup;

    inputPrefixPhone: any;
    inputPhoneNo: any;
    isEmailEditControlDisabled = false;
    isalertVisiable = false;

    ddldebtorPhonePrefix: any;



    constructor
        (
            private customerService: CustomerService
            , private _fb: FormBuilder, private _fbpass: FormBuilder
            , private parameterData: ParameterData
            , private router: Router, private route: ActivatedRoute
            , private dataService: DataService
            , private datePipe: DatePipe
            , private auth: AuthService
            , private userService: UserService
            , private _debtorPhonePrefix: debtorPhonePrefix
            , private spinnerService: Ng4LoadingSpinnerService,
            private documentService: DocumentService
        ) {
        this.userKcoreId = localStorage.getItem('userId');

        this.isEmailEditControlDisabled = false;
        this.isalertVisiable = false;

        this.InitialSetup();

    }//end constructor




    ngOnInit() {
        this.spinnerService.show();
        let country = localStorage.getItem("country")
        this.ddldebtorPhonePrefix = this.documentService.getPrefixByIsoAlpha2(country);
        if (this.userKcoreId != null) {
            this.isEmailEditControlDisabled = true;
            this.userService.getUser(this.userKcoreId).subscribe((user: User) => {
                this.inputPrefixPhone = this.documentService.getCountryCode(user.phone);
                console.log(this.inputPrefixPhone);

                this.editUserName = user.name;

                setTimeout(() => {
                    this.profileForm = this._fb.group({
                        name: new FormControl(user.name),
                        email: new FormControl(user.email),

                        phone: new FormControl(this.documentService.getPhoneNumberOnly(user.phone))

                    });
                }, 500)
                this.spinnerService.hide();
            })
        }

    }//end ngOnInit



    /**
     * this InitialSetup function is used to initialize the form controls 
     */
    InitialSetup() {

        this.profileForm = this._fb.group({
            id: new FormControl(0),
            name: new FormControl("", Validators.required),
            email: new FormControl("", [Validators.required, Validators.email]),
            phone: new FormControl(""),
        });

        this.passwordForm = this._fbpass.group({
            newPassword: new FormControl("", Validators.compose([
                Validators.required,
                // check whether the entered password has a number
                ConfirmPasswordValidator.patternValidator(/\d/, {
                    hasNumber: true
                }),
                // check whether the entered password has upper case letter
                ConfirmPasswordValidator.patternValidator(/[A-Z]/, {
                    hasCapitalCase: true
                }),
                // check whether the entered password has a lower case letter
                ConfirmPasswordValidator.patternValidator(/[a-z]/, { hasSmallCase: true }),
                // check whether the entered password has a special character
                ConfirmPasswordValidator.patternValidator(/[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/,
                    {
                        hasSpecialCharacters: true
                    }
                ),
                Validators.minLength(8)
            ])),
            confirmPassword: new FormControl("", Validators.compose([Validators.required]))
        },
            {
                validator: ConfirmPasswordValidator.passwordMatchValidator
            });


    }//end InitialSetup



    /**
     * this submit function is used to save the data, sends the input data to api
     */
    onsubmit({ value }: { value: User }) {
        this.spinnerService.show();
        if (!(this.inputPrefixPhone == undefined || this.inputPrefixPhone == null)) {
            value.phone = this.inputPrefixPhone + value.phone;
        }
       
        if (value.name === null) {
            value.id = 0;
        }
        if (value.name != null && value.name != undefined && value.name != "") {
            this.userService.updateUser(this.userKcoreId, value)
                .subscribe((result) => {
                    this.spinnerService.hide();
                    this.isalertVisiable = true;
                }, error => {
                    console.log('Failed while trying to update the user details.' + error);
                });

        }
       
    }//end


    onsubmitpass({ value }: { value: ChangePassword }) {

        if (value.newPassword != null && value.newPassword != undefined && value.newPassword != "") {
            this.userService.changepassword(this.userKcoreId, value)
                .subscribe((result) => {

                    this.isalertVisiable = true;
                }, error => {
                    console.log('Failed while trying to update the user password details.' + error);
                });

        }

    }//end

    numberOnly(event): boolean {
        const charCode = (event.which) ? event.which : event.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            if (!((charCode >= 37 && charCode <= 42) || charCode == 45 || charCode == 46 || charCode == 35 || charCode == 32)) {
                return false;
            }
        }
        return true;

    }

}//end class
